require('angular-translate')

angular.module 'gnp-translation', ['pascalprecht.translate']
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider.determinePreferredLanguage()
    $translateProvider
      .translations 'en', require('./common.en.coffee')
      .translations 'ja', require('./common.ja.coffee')
  ]
  .run ['$translate', ($translate) ->
    if /^ja/i.test $translate.preferredLanguage()
      $translate.use('ja')
    else
      $translate.use('en')
  ]



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/core/translation/translation-module.coffee